/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Features_OverlineInputs */

const en_mk_features_overline = /** @type {(inputs: Mk_Features_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLATFORM CAPABILITIES`)
};

const id_mk_features_overline = /** @type {(inputs: Mk_Features_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KEMAMPUAN PLATFORM`)
};

/**
* | output |
* | --- |
* | "PLATFORM CAPABILITIES" |
*
* @param {Mk_Features_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_features_overline = /** @type {((inputs?: Mk_Features_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Features_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_features_overline(inputs)
	return en_mk_features_overline(inputs)
});